<div class="buying-window--select">
    <ng-container *ngIf="hasOrderWindows; else noAvailableWindow">
        <ng-container *ngTemplateOutlet="mobile ? mobileView : desktopView"></ng-container>
    </ng-container>
</div>

<ng-template #noAvailableWindow>
    <p class="uppercase m-0">No {{orderWindowLabel}}s are available</p>
</ng-template>

<ng-template  #desktopView >
    <ng-container *ngIf="!hideTitle">
        <h3>choose window</h3>
        <p class="font-5 uppercase">shop current {{orderWindowLabel}} or view past {{orderWindowLabel}}s</p>
    </ng-container>
    <ng-select
            class="order-window-select"
            [items]="orderWindows"
            bindLabel="label"
            bindValue="id"
            [searchable]="false"
            [clearable]="false"
            (change)="onChangeOrderWindow($event)"
            name="order"
            placeholder="Please select {{orderWindowLabel}}"
            [(ngModel)]="selectedOrderWindowId">
        <ng-template ng-label-tmp let-item="item">
            <span [innerHTML]="formattedLabel(item) | safeContent"></span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
            <span [innerHTML]="formattedLabel(item) | safeContent"></span>
        </ng-template>
    </ng-select>
</ng-template>

<ng-template #mobileView>
    <ng-container *ngIf="!hideTitle">
        <h3 style="text-transform: capitalize">choose window</h3>
        <p class="font-6 uppercase">shop current {{orderWindowLabel}} or view past {{orderWindowLabel}}s</p>
    </ng-container>
    <ng-select
            class="order-window-select mobile"
            [items]="orderWindows"
            bindLabel="label"
            bindValue="id"
            [searchable]="false"
            [clearable]="false"
            (change)="onChangeOrderWindow($event)"
            name="order"
            placeholder="Please select {{orderWindowLabel}}"
            [(ngModel)]="selectedOrderWindowId">
        <ng-template ng-label-tmp let-item="item">
            <span class="d-block font-weight-bold" [innerHTML]="item.label | safeContent"></span>
            <span class="font-weight-bold" [ngClass]="{'color-green': item.active, 'color-red': !item.active}">{{ formattedDates(item) }}</span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
            <span class="d-block font-weight-bold" [innerHTML]="item.label | safeContent"></span>
            <span class="d-block font-weight-bold" [ngClass]="{'color-green': item.active, 'color-red': !item.active}">{{ formattedDates(item) }}</span>
        </ng-template>
    </ng-select>
</ng-template>

